export const identity = {
  'name': 'Vishal Jeyaram',
  'topName' : ' VISHAL ',
  'bottomName' : ' JEYARAM '
};
